import Button from "components/common/Button/Button";
import Title from "components/common/Title";
import * as React from "react";
import { Col, Row } from "react-grid-system";
import { Link } from "react-router-dom";
import { Routes } from "router";
import styled from "styled-components";
import theme from "themes/simple-theme";

interface IProps {
  total: number;
  pointsBalance: number;
}

const PointsSummary = ({ pointsBalance, total }: IProps) => (
  <Row align="center">
    <Col md={12} align="center">
      <Total>
        <Title id="points-summary-total" noPadding bold>
          {total}
        </Title>
        <SubHeading>Points Redeemed Today</SubHeading>
      </Total>
    </Col>
    <Col md={12} align="center">
      <Balance>
        <Title id="points-summary-balance" noPadding bold>
          {pointsBalance}
        </Title>
        <SubHeading>Total Points Remaining</SubHeading>
      </Balance>
      <Link to={Routes.Main}>
        <Button primary wide>
          Return to Dashboard
        </Button>
      </Link>
    </Col>
  </Row>
);

const Total = styled.div`
  padding-bottom: 60px;
  border-bottom: 1px solid ${theme.color.primary};
  color: ${theme.color.primary};
`;

const Balance = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
  color: ${theme.color.primary};
`;

const SubHeading = styled.p`
  font-size: 16px;
  margin-top: 10px;
  text-transform: uppercase;
  color: ${theme.color.primary};
`;

export default PointsSummary;



// WEBPACK FOOTER //
// ./src/screens/RedeemRewards/RedeemCompelte/PointsSummary.tsx